// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CategoryArticles_wrapper__0CAmr","title":"CategoryArticles_title__mrhmD"};